export function getPlainText(richText: string): string {
    if (!richText) {
        richText = '';
    }

    return richText.replace(/<[^>]+>/g, '');
}
